import TableCellSelectKeyword from './TableCellSelectKeyword';
import './TableCellSelectKeyword.scss';

export default TableCellSelectKeyword;
